"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var eventemitter3_1 = require("eventemitter3");
var LocalEvent;
(function (LocalEvent) {
    LocalEvent["EDITOR_CREATED"] = "editor-created";
    LocalEvent["TEXT_CHANGED"] = "text-change";
    LocalEvent["SELECTION_CHANGED"] = "selection-change";
    LocalEvent["ON_CHANGE"] = "state-change";
    LocalEvent["ON_BLUR"] = "blur";
    LocalEvent["ON_FOCUS"] = "focus";
    LocalEvent["EDITOR_WILL_UNMOUNT"] = "editor-will-unmount";
    LocalEvent["SWITCH_LAYER"] = "switch-layer";
    LocalEvent["LOCALE_CHANGE"] = "locale-change";
})(LocalEvent || (LocalEvent = {}));
exports.LocalEvent = LocalEvent;
var EventChannel = /** @class */ (function (_super) {
    __extends(EventChannel, _super);
    function EventChannel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EventChannel.LocalEvent = LocalEvent;
    return EventChannel;
}(eventemitter3_1.EventEmitter));
exports.EventChannel = EventChannel;
//# sourceMappingURL=event.js.map